module.exports = __webpack_public_path__ + "img/370.e6bfe1a9.jpg";